// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"G8-z"};